/**
 * Replaces em dashes with a regular hyphen in SEO copy. Handles the literal
 * character (U+2014) as well as its common HTML-entity encodings, since CMS
 * content may store either form. Existing spacing is preserved, so "a — b"
 * becomes "a - b" and "a—b" becomes "a-b".
 */
export const replaceEmDashes = (text: string): string => {
    if (!text) {
        return text;
    }
    return text.replace(/\u2014|&mdash;|&#8212;|&#x2014;/gi, '-');
};
